import React, { FunctionComponent, useEffect, useState } from 'react'
import { Button, List, Modal, notification, Space } from 'antd'
import { Link, useParams } from 'react-router'
import { ModalFuncProps } from "antd/lib/modal/interface";
import { AssetDto, BrokerDto, BrokerPositionDto, BrokersService } from '../api';
import { BrokerBalanceHistory } from '../components/brokerBalanceHistory';

type BrokerParams = { id: string }

interface BrokerPageProps {}

export const BrokerPage: FunctionComponent<BrokerPageProps> = ({ }) => {
  const params = useParams<BrokerParams>()
  const [modal, contextHolder] = Modal.useModal()

  const [broker, setBroker] = useState<BrokerDto | null>(null)
  const [assets, setAssets] = useState<AssetDto[]>([])
  const [positions, setPositions] = useState<BrokerPositionDto[]>([])
  // TODO: add accounts

  const fetchBroker = async () => {
    const response = await BrokersService.getBroker({ broker: params.id! })
    setBroker(response.broker)
  }
  const fetchAssets = async () => {
    const response = await BrokersService.getBrokerAssets({ broker: params.id! })
    setAssets(response.assets)
  }
  const fetchPositions = async () => {
    const response = await BrokersService.getBrokerPositions({ broker: params.id! })
    setPositions(response.positions)
  }

  useEffect(() => {
    fetchBroker()
    fetchAssets()
    fetchPositions()
  }, [params.id])

  const modalSwitchState: ModalFuncProps = {
    title: 'Are you sure?',
    content: 'No broker will be able to order or subscribe, you must be sure to be outside market opening hours.',
    onOk: async () => {
      try {
        await BrokersService.setBroker({
          broker: broker!.name,
          requestBody: {
            broker: {
              state: broker!.state === 'started' ? 'paused' : 'started'
            }
          }
        })
        notification.success({
          message: 'Broker modified',
          description: 'State has been modified'
        })
      } catch (e: any) {
        console.error(e)
        notification.error({
          message: 'Error',
          description: e.toString()
        })
      }
    }
  }

  return <>
    <h2>Broker {params.id}</h2>
    <div>
      <h3>Data</h3>
      <pre>{JSON.stringify(broker, null, 2)}</pre>
      <Button onClick={() => modal.confirm(modalSwitchState)}>Switch state</Button>
    </div>
    <div>
      <h3>Account value</h3>
      <BrokerBalanceHistory broker={params.id!} />
    </div>
    <div>
      <h3>Positions</h3>
      <List>
        {
          positions.map(position => <List.Item>
            <List.Item.Meta title="Action" description={position.action} />
            <List.Item.Meta title="Quantity" description={position.quantity} />
          </List.Item>)
        }
      </List>
    </div>
    <div>
      <h3>Assets</h3>
      <List>
        {
          assets.map(asset => <List.Item>
            <List.Item.Meta title="Symbol" description={asset.symbol} />
            { asset.meta && Object.keys(asset.meta).map(key => <List.Item.Meta title={key} description={asset.meta![key] as any} />)}
            <Button href={`/brokers/${params.id}/assets/${asset.symbol}`}>See more</Button>
          </List.Item>)
        }
      </List>
    </div>
    {contextHolder}
  </>
}